module.exports = __webpack_public_path__ + "img/10.31a5bb94.jpg";